import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  Box,
  Typography,
  IconButton,
  useTheme // برای دسترسی به تم
} from '@mui/material';
import { useField } from 'formik';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const TextFieldIcon = ({
  mainLabel = '',
  name,
  label,
  icon: IconComponent,
  formik,
  type,
  // پراپرتی جدید برای تعیین رنگ، مثلاً 'errorColor' یا 'highlightColor'
  // این پراپرتی اگر true باشد، رنگ مورد نظر از تم انتخاب می‌شود
  shouldUseHighlightColor = false,
  highlightColorPalette = 'error.main', // مثلا 'error.main', 'primary.main', 'secondary.light'
  ...otherProps
}) => {
  const field = useField(name)[0]; // فقط field لازم است در اینجا
  const meta = useField(name)[1]; // فقط meta لازم است در اینجا
  const theme = useTheme(); // دسترسی به تم

  const showError = meta.touched && meta.error;
  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  // تعیین رنگ بر اساس پراپرتی و تم
  const inputBorderColor = shouldUseHighlightColor
    ? theme.palette[highlightColorPalette.split('.')[0]][highlightColorPalette.split('.')[1]]
    : undefined; // اگر شرط false باشد، رنگ پیش‌فرض MUI استفاده می‌شود

  // تعیین رنگ برای حاشیه خطا اگر وجود داشته باشد
  const errorBorderColor = theme.palette.error.main;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'start', width: '100%', flexDirection: 'column', p: 1 }}>
      <Typography variant='caption' sx={{ mb: 0.5, pl: 0.5 }}>
        {mainLabel}
      </Typography>
      <Box sx={{ position: 'relative', width: '100%' }}>
        <TextField
          {...field}
          {...otherProps}
          name={name}
          fullWidth
          type={isPassword && !showPassword ? 'password' : 'text'}
          size="small"
          // اینجا استایل‌ها را برای رنگ حاشیه اعمال می‌کنیم
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                // اگر رنگ برجسته بخواهیم، از آن استفاده کن، در غیر این صورت پیش‌فرض
                borderColor: showError ? errorBorderColor : inputBorderColor,
              },
              '&:hover fieldset': {
                // برای حالت هاور هم می‌توان رنگ را تنظیم کرد
                borderColor: showError ? errorBorderColor : (inputBorderColor || 'primary.main'), // اگر highlight نباشد، primary.main
              },
            },
            '& .MuiInputBase-input': {
              padding: '8px 25px',
              // bgColor:'red' // این پراپرتی باید در sx لایه بالاتر باشد، اینجا کار نمی‌کند
            },
            // اگر بخواهیم کل input (بک‌گراند) تغییر کند:
            // bgcolor: shouldUseHighlightColor ? 'rgba(255, 0, 0, 0.1)' : 'transparent'
          }}
          label=""
          error={showError}
          helperText={showError ? meta.error : null}
          InputProps={{
            startAdornment: IconComponent && ( // استفاده از startAdornment برای آیکون ورودی
              <InputAdornment position="start">
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'grey.500' }}>
                  <IconComponent fontSize="small" />
                </Box>
              </InputAdornment>
            ),
            endAdornment: isPassword && (
              <InputAdornment position="end">
                <IconButton
                  size={'small'}
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? (
                    <VisibilityOff sx={{ fontSize: '1.2rem' }} />
                  ) : (
                    <Visibility sx={{ fontSize: '1.2rem' }} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default TextFieldIcon;
